import getConfigDetails from '../services/config'

export const APICONFIG = {
	getLoginUrl: `${getConfigDetails.API_BASE_URL}login`,
	getPaymentInitialUrl: `${getConfigDetails.API_BASE_URL}planet-payment-session`,
	getEventListUrl: `${getConfigDetails.API_BASE_URL}get-mapco-event-list`,
	getPassListUrl: `${getConfigDetails.API_BASE_URL}get-mapco-passes`,
	getAfterPaymentSuccess: `${getConfigDetails.API_BASE_URL}mapco-payment-success`,
	downloadQrcodeRequestUrl: `${getConfigDetails.API_BASE_URL}mapco-download-qrcode`,
	// getPromoCodeUrl: `${getConfigDetails.API_BASE_URL}validate_promocode`,
	getPromoCodeUrl: `${getConfigDetails.API_BASE_URL}mapco_validate_promocode`,
	getPromoCodeUsage: `${getConfigDetails.API_BASE_URL}update_promocode_usage`,
	getEventLogUrl: `${getConfigDetails.API_BASE_URL}addUserEvent`,
	// getIpDetailUrl: 'https://get-ip-only.herokuapp.com/',
	getIpDetailUrl: 'https://geolocation-db.com/json/',
	getOtpUrl: `${getConfigDetails.API_BASE_URL}send-otp`,
	getConfirmOtpUrl: `${getConfigDetails.API_BASE_URL}confirm-otp`,
	saveBookingBeforePaymentUrl: `${getConfigDetails.API_BASE_URL}mapco-booking-before-payment`,
	saveBookingafterPaymentUrl: `${getConfigDetails.API_BASE_URL}mapco-booking-after-payment`,
}

export const getDynamicUrl = (id) =>
	`${getConfigDetails.API_BASE_URL}/services/${id}/service-meters`

